import { useNavigate } from 'react-router';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import InfoContent from '../../components/InfoContent';
import { useEffect } from 'react';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem('user');
  }, []);

  return (
    <main className="relative z-10 flex flex-1 flex-col items-center justify-between gap-10 pb-5">
      <div className="flex flex-1 flex-col justify-center">
        <InfoContent
          icon={<WarningIcon className="h-100 w-100 lg:h-150 lg:w-150" />}
          title="Subscription Cancelled"
          description="To maintain access to EHS Navigator, you’ll need to subscribe to one of our plans."
          buttonLabel="Back To Sign In"
          warn
          handleClick={() => navigate('/sign-in')}
        />
      </div>
    </main>
  );
}
